<template>
  <FullScreenLayoutContent
    :class="[
      data &&
        data.superpower &&
        `bg-${data.superpower.color}-95 ${data.superpower.color}-container`,
    ]"
  >
    <template #header>
      <div class="p-4">
        <BaseIconButton icon="close" size="M" @click="router.push({ name: 'dashboard' })" />
      </div>
    </template>
    <LoadingWrapper :state="status">
      <div v-if="data.superpower" class="flex grow flex-col p-4 lg:p-0">
        <div class="flex grow flex-col justify-center">
          <div class="flex items-center gap-2">
            <div class="relative flex items-center justify-center p-3">
              <BaseIcon size="32" :filled="true" class="text-on-primary-container z-20">{{
                data.superpowerTopic?.icon
              }}</BaseIcon>
              <BaseShape
                shape="slanted"
                class="text-primary-container absolute z-10 h-full w-full"
              />
            </div>
            <h3 class="text-headline-small text-on-primary-container">Deine Superkraft</h3>
          </div>
          <div
            class="rounded-large md:rounded-extra-large bg-primary mt-6 flex flex-col items-center gap-4 p-6 lg:grid lg:grid-cols-[30%_70%] lg:p-8"
          >
            <div class="relative flex h-48 w-48 items-center justify-center p-3 lg:h-64 lg:w-64">
              <BaseShapeMask
                shape="9-sided-cookie"
                :scale="1.1"
                class="z-20"
                animation="spin"
                animation-duration="10s"
              >
                <img :src="data.superpower.image" :alt="data.superpower.title" />
              </BaseShapeMask>
            </div>
            <div class="text-on-primary">
              <h2
                class="text-headline-large sm:text-display-small md:text-display-large text-on-primary wrap-break-words mb-2 hyphens-auto"
              >
                {{ data.superpower.title }}
              </h2>
              <p class="text-body-large">
                {{ data.superpower.shortDescription }}
              </p>
            </div>
          </div>
          <div v-if="data.superpower.mission" class="mt-10">
            <h3 class="text-title-large mb-2">Deine erste Mission</h3>
            <p class="text-body-large">
              {{ data.superpower.mission }}
            </p>
          </div>
        </div>
        <div class="flex w-full flex-row justify-end gap-2 py-4 md:pb-8">
          <a :href="data.superpower.pdf" target="_blank" :download="data.superpower.title + '.pdf'">
            <BaseTextButton v-if="data.superpower.pdf" icon="download" color="tonal" size="M"
              >PDF mit weiteren Informationen</BaseTextButton
            ></a
          >
          <BaseTextButton color="tonal" size="M" @click="router.push({ name: 'dashboard' })">{{
            $t('common.close')
          }}</BaseTextButton>
        </div>
      </div>
      <div
        v-else-if="data.superpowerTopic"
        class="flex grow flex-col items-center justify-center p-4 text-center lg:p-0"
      >
        <EmptyPage
          title="Finde deine Superkraft heraus!"
          :description="data.superpowerTopic.excerpt ?? ''"
          :icon="data.superpowerTopic.icon ?? 'self_improvement'"
        >
          <BaseTextButton
            color="filled"
            size="M"
            trailing-icon="start"
            @click="startSuperpowerSurvey"
            >Superkraft herausfinden</BaseTextButton
          >
        </EmptyPage>
      </div>
      <div v-else class="flex grow flex-col items-center justify-center p-4 text-center lg:p-0">
        <EmptyPage
          title="Kein Superkraft Template gefunden!"
          description="In deiner Organisation scheint es kein Superkraft Teamplate zu geben.Sprich mit dem Admin deiner Organisation darüber!"
          icon="self_improvement"
        >
          <RouterLink :to="{ name: 'dashboard' }">
            <BaseTextButton color="filled" size="M" trailing-icon="start">{{
              $t('common.close')
            }}</BaseTextButton>
          </RouterLink>
        </EmptyPage>
      </div>
    </LoadingWrapper>
  </FullScreenLayoutContent>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import FullScreenLayoutContent from '../../../core/components/layouts/FullScreenLayoutContent.vue'
  import { useSuperpower } from '../../../core/composables/use-superpower'
  import BaseShapeMask from '../../../core/components/base/shapes/BaseShapeMask.vue'
  import BaseShape from '../../../core/components/base/shapes/BaseShape.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import EmptyPage from '../../../core/components/empty-states/EmptyPage.vue'
  import BaseIcon from '../../../core/components/base/icon/BaseIcon.vue'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'

  const router = useRouter()
  const { data, status, startSuperpowerSurvey } = useSuperpower()
</script>
